// ENHANCED MOBILE MENU - Desktop-style design with product images (Performance Optimized)

(function() {
  'use strict';
  
  let isMenuOpen = false;
  let menuOverlay = null;
  
  // Product images mapping (from nav-item.liquid)
  const productImages = {
    'Turnkey Racing Simulators': 'https://simcoaches.com/cdn/shop/t/63/assets/nav-turnkey-racing-simulators.png',
    'Elite Racing Simulator': 'https://cdn.shopify.com/s/files/1/0534/2206/3807/files/elite-racing-simulator-high-end-turnkey-solution_jpg.png?v=1752707674',
    'Pro Racing Simulator': 'https://cdn.shopify.com/s/files/1/0534/2206/3807/files/pro-racing-simulator-turnkey-simcoaches_jpg.png?v=1752707674',
    'Omega Racing Simulator': 'https://cdn.shopify.com/s/files/1/0534/2206/3807/files/omega-racing-simulator-3dof-motion-platform_jpg.png?v=1752707674',
    'Compare Simulators': 'https://cdn.shopify.com/s/files/1/0534/2206/3807/files/Sim-Coaches-turnkey-racing-simulator-range.png?v=1752707302',
    'Standard Pedals': 'https://cdn.shopify.com/s/files/1/0534/2206/3807/files/best-hydraulic-sim-pedals-for-racing-simcoaches.png?v=1752708699',
    'Inverted Pedals': 'https://cdn.shopify.com/s/files/1/0534/2206/3807/files/best-inverted-sim-racing-pedals-hydraulic-pro-simcoaches.png?v=1752708699',
    'Hydraulic Handbrake': 'https://cdn.shopify.com/s/files/1/0534/2206/3807/files/pro-hydraulic-handbrake-sim-racing-simcoaches.png?v=1752708699',
    'Handbrake': 'https://cdn.shopify.com/s/files/1/0534/2206/3807/files/pro-hydraulic-handbrake-sim-racing-simcoaches.png?v=1752708699',
    'Pedals': 'https://cdn.shopify.com/s/files/1/0534/2206/3807/files/best-hydraulic-sim-pedals-for-racing-simcoaches.png?v=1752708699'
  };
  
  // Product descriptions mapping
  const productDescriptions = {
    'Turnkey Racing Simulators': 'Complete ready-to-race simulators',
    'Elite Racing Simulator': '6DOF Motion Racing Simulator',
    'Pro Racing Simulator': 'Static Racing Simulator',
    'Omega Racing Simulator': '3DOF Motion Racing Simulator',
    'Compare Simulators': 'Compare all racing simulators',
    'Standard Pedals': 'Hydraulic sim racing pedals',
    'Inverted Pedals': 'Inverted hydraulic sim pedals',
    'Hydraulic Handbrake': 'Quality racing equipment',
    'Handbrake': 'Hydraulic sim handbrake',
    'Pedals': 'Hydraulic sim racing pedals'
  };
  
  function createEnhancedMenu() {
    // Remove any existing overlay
    const existingOverlay = document.getElementById('enhanced-mobile-menu');
    if (existingOverlay) {
      existingOverlay.remove();
    }
    
    // Create overlay container
    menuOverlay = document.createElement('div');
    menuOverlay.id = 'enhanced-mobile-menu';
    
    // Create the overlay background
    const overlayBg = document.createElement('div');
    overlayBg.style.cssText = `
      position: fixed;
      top: 70px;
      left: 0;
      width: 100vw;
      height: calc(100vh - 70px);
      background: linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,249,250,0.95) 100%);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      z-index: 999;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding: 20px;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    `;
    
    // Create the menu content
    const menuContent = document.createElement('div');
    menuContent.style.cssText = `
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      width: 100%;
      max-width: 420px;
      border-radius: 16px;
      padding: 24px;
      box-shadow: 0 8px 32px rgba(0,0,0,0.12), 0 2px 16px rgba(0,0,0,0.08);
      position: relative;
      border: 1px solid rgba(255,255,255,0.3);
      margin-top: 20px;
    `;
    
    // Create close button (desktop-style)
    const closeBtn = document.createElement('button');
    closeBtn.id = 'enhanced-close';
    closeBtn.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    `;
    closeBtn.style.cssText = `
      position: absolute;
      top: 16px;
      right: 16px;
      background: rgba(0,0,0,0.05);
      color: #666;
      border: none;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      z-index: 10;
    `;
    
    // Add hover effect to close button
    closeBtn.addEventListener('mouseenter', function() {
      this.style.background = 'rgba(0,0,0,0.1)';
      this.style.color = '#333';
      this.style.transform = 'scale(1.1)';
    });
    
    closeBtn.addEventListener('mouseleave', function() {
      this.style.background = 'rgba(0,0,0,0.05)';
      this.style.color = '#666';
      this.style.transform = 'scale(1)';
    });
    
    // Create navigation
    const nav = document.createElement('nav');
    nav.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 0;
      padding-top: 20px;
    `;
    
    // Get navigation data from the page
    let navData = null;
    try {
      const navDataElement = document.getElementById('navigation-data');
      if (navDataElement) {
        navData = JSON.parse(navDataElement.textContent);
      }
    } catch (error) {
      // Silently handle error
    }
    
    // Create main navigation links
    if (navData && navData.links) {
      navData.links.forEach(linkData => {
        const linkContainer = document.createElement('div');
        linkContainer.style.cssText = `
          margin-bottom: 4px;
        `;
        
        // Create main link
        const mainLink = document.createElement('a');
        mainLink.href = linkData.url;
        mainLink.textContent = linkData.title;
        mainLink.style.cssText = `
          display: block;
          padding: 16px 0;
          color: #1a1a1a;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
          border-bottom: 1px solid rgba(0,0,0,0.08);
          transition: all 0.3s ease;
          position: relative;
        `;
        
        // Add hover effect
        mainLink.addEventListener('mouseenter', function() {
          this.style.color = '#ff6b6b';
        });
        
        mainLink.addEventListener('mouseleave', function() {
          this.style.color = '#1a1a1a';
        });
        
        linkContainer.appendChild(mainLink);
        
        // Add children (submenu items) with desktop-style design
        if (linkData.children && linkData.children.length > 0) {
          const submenuContainer = document.createElement('div');
          submenuContainer.style.cssText = `
            padding-left: 8px;
            margin-bottom: 16px;
          `;
          
          linkData.children.forEach(childLink => {
            const childLinkElement = document.createElement('a');
            childLinkElement.href = childLink.url;
            
            // Get product image and description if available
            const productImage = productImages[childLink.title];
            const productDesc = productDescriptions[childLink.title];
            
            if (productImage) {
              // Create desktop-style product link with image
              childLinkElement.innerHTML = `
                <div class="mobile-mega-menu__image-container">
                  <img src="${productImage}" alt="${childLink.title}" class="mobile-mega-menu__image">
                </div>
                <div class="mobile-mega-menu__content">
                  <div class="mobile-mega-menu__title">${childLink.title}</div>
                  ${productDesc ? `<div class="mobile-mega-menu__description">${productDesc}</div>` : ''}
                </div>
              `;
              
              childLinkElement.style.cssText = `
                display: flex !important;
                align-items: center !important;
                gap: 12px !important;
                padding: 12px 16px !important;
                margin: 4px 0 !important;
                background: rgba(255,255,255,0.6) !important;
                border-radius: 10px !important;
                text-decoration: none !important;
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
                border: 1px solid rgba(0,0,0,0.05) !important;
              `;
            } else {
              // Standard link without image
              childLinkElement.textContent = childLink.title;
              childLinkElement.style.cssText = `
                display: block;
                padding: 10px 16px;
                margin: 4px 0;
                background: rgba(255,255,255,0.6);
                border-radius: 8px;
                color: #555;
                text-decoration: none;
                font-weight: 500;
                font-size: 14px;
                transition: all 0.3s ease;
                border: 1px solid rgba(0,0,0,0.05);
              `;
            }
            
            // Add hover effects
            childLinkElement.addEventListener('mouseenter', function() {
              if (productImage) {
                this.style.background = 'rgba(255, 107, 107, 0.08)';
                this.style.transform = 'translateY(-2px)';
                this.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
              } else {
                this.style.background = 'rgba(255, 107, 107, 0.05)';
                this.style.color = '#ff6b6b';
              }
            });
            
            childLinkElement.addEventListener('mouseleave', function() {
              if (productImage) {
                this.style.background = 'rgba(255,255,255,0.6)';
                this.style.transform = 'translateY(0)';
                this.style.boxShadow = 'none';
              } else {
                this.style.background = 'rgba(255,255,255,0.6)';
                this.style.color = '#555';
              }
            });
            
            // Add click handler to close menu
            childLinkElement.addEventListener('click', function() {
              setTimeout(() => closeEnhancedMenu(), 150);
            });
            
            submenuContainer.appendChild(childLinkElement);
          });
          
          linkContainer.appendChild(submenuContainer);
        }
        
        // Add click handler to main link
        mainLink.addEventListener('click', function() {
          setTimeout(() => closeEnhancedMenu(), 150);
        });
        
        nav.appendChild(linkContainer);
      });
    }
    
    // Add utility links (Account, Cart) with desktop styling
    if (navData && navData.utilities) {
      const utilitiesContainer = document.createElement('div');
      utilitiesContainer.style.cssText = `
        border-top: 1px solid rgba(0,0,0,0.08);
        padding-top: 16px;
        margin-top: 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
      `;
      
      navData.utilities.forEach(utilityLink => {
        const utilityElement = document.createElement('a');
        utilityElement.href = utilityLink.url;
        utilityElement.textContent = utilityLink.title;
        utilityElement.style.cssText = `
          display: block;
          padding: 12px 16px;
          background: ${utilityLink.icon === 'cart' ? 
            'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 
            'rgba(255,255,255,0.6)'};
          color: ${utilityLink.icon === 'cart' ? 'white' : '#1a1a1a'};
          text-decoration: none;
          border-radius: 8px;
          font-weight: 600;
          font-size: 14px;
          transition: all 0.3s ease;
          border: 1px solid ${utilityLink.icon === 'cart' ? 
            'rgba(255,255,255,0.2)' : 
            'rgba(0,0,0,0.05)'};
        `;
        
        // Add hover effects
        utilityElement.addEventListener('mouseenter', function() {
          if (utilityLink.icon === 'cart') {
            this.style.background = 'linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)';
            this.style.transform = 'translateY(-1px)';
          } else {
            this.style.background = 'rgba(255, 107, 107, 0.05)';
            this.style.color = '#ff6b6b';
          }
        });
        
        utilityElement.addEventListener('mouseleave', function() {
          if (utilityLink.icon === 'cart') {
            this.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
            this.style.transform = 'translateY(0)';
          } else {
            this.style.background = 'rgba(255,255,255,0.6)';
            this.style.color = '#1a1a1a';
          }
        });
        
        // Add click handler to close menu
        utilityElement.addEventListener('click', function() {
          setTimeout(() => closeEnhancedMenu(), 150);
        });
        
        utilitiesContainer.appendChild(utilityElement);
      });
      
      nav.appendChild(utilitiesContainer);
    }
    
    // Assemble the menu
    menuContent.appendChild(closeBtn);
    menuContent.appendChild(nav);
    overlayBg.appendChild(menuContent);
    menuOverlay.appendChild(overlayBg);
    
    // Add to body
    document.body.appendChild(menuOverlay);
    
    // Add close functionality
    closeBtn.addEventListener('click', closeEnhancedMenu);
    
    // Add overlay click to close
    overlayBg.addEventListener('click', function(e) {
      if (e.target === overlayBg) {
        closeEnhancedMenu();
      }
    });
    
    return menuOverlay;
  }
  
  function openEnhancedMenu() {
    if (!menuOverlay) {
      menuOverlay = createEnhancedMenu();
    }
    
    // Force show with maximum priority
    const overlay = menuOverlay.firstElementChild;
    overlay.style.opacity = '1';
    overlay.style.visibility = 'visible';
    
    isMenuOpen = true;
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
    
    // Focus trap
    const closeBtn = document.getElementById('enhanced-close');
    if (closeBtn) {
      closeBtn.focus();
    }
  }
  
  function closeEnhancedMenu() {
    if (menuOverlay) {
      const overlay = menuOverlay.firstElementChild;
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      
      setTimeout(() => {
        if (menuOverlay && menuOverlay.parentNode) {
          menuOverlay.remove();
          menuOverlay = null;
        }
      }, 300);
    }
    
    isMenuOpen = false;
    document.body.style.overflow = '';
  }
  
  function toggleEnhancedMenu() {
    if (isMenuOpen) {
      closeEnhancedMenu();
    } else {
      openEnhancedMenu();
    }
  }
  
  function initEnhancedMenu() {
    // Find toggle buttons with performance optimization
    const toggleSelectors = [
      '.header__mobile-toggle',
      '[data-header-target="mobileMenu"]',
      '.mobile-menu-toggle',
      '.hamburger',
      '.menu-toggle',
      'button[aria-label*="menu"]',
      'button[aria-label*="Menu"]'
    ];
    
    let toggleFound = false;
    
    // Use more efficient selector approach
    const allToggles = document.querySelectorAll(toggleSelectors.join(', '));
    
    allToggles.forEach(toggle => {
      if (toggle) {
        // Remove existing event listeners by cloning
        const newToggle = toggle.cloneNode(true);
        toggle.parentNode.replaceChild(newToggle, toggle);
        
        // Add our enhanced event listener
        newToggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          toggleEnhancedMenu();
        });
        
        toggleFound = true;
      }
    });
    
    // Add escape key listener
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isMenuOpen) {
        closeEnhancedMenu();
      }
    });
  }
  
  // Initialize on DOM content loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEnhancedMenu);
  } else {
    initEnhancedMenu();
  }
  
  // Backup initialization with reduced timeout
  setTimeout(initEnhancedMenu, 500);
})();

// CSS for mobile mega menu styling (performance optimized)
const mobileMenuCSS = `
<style>
  .mobile-mega-menu__image-container {
    flex-shrink: 0;
    width: 100px;
    height: 50px;
    border-radius: 6px;
    overflow: hidden;
    background: #f8f9fa;
    border: 1px solid rgba(0,0,0,0.05);
    transition: all 0.3s ease;
  }
  
  .mobile-mega-menu__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  .mobile-mega-menu__content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .mobile-mega-menu__title {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 2px;
    line-height: 1.2;
  }
  
  .mobile-mega-menu__description {
    font-size: 12px;
    color: #666;
    line-height: 1.3;
    opacity: 0.9;
  }
  
  /* Hover effects */
  a:hover .mobile-mega-menu__image-container {
    border-color: rgba(255, 107, 107, 0.2);
    transform: scale(1.05);
  }
  
  a:hover .mobile-mega-menu__image {
    transform: scale(1.1);
  }
  
  a:hover .mobile-mega-menu__title {
    color: #ff6b6b;
  }
  
  a:hover .mobile-mega-menu__description {
    opacity: 1;
  }
</style>
`;

// Inject CSS efficiently
if (!document.getElementById('mobile-menu-styles')) {
  const styleElement = document.createElement('div');
  styleElement.id = 'mobile-menu-styles';
  styleElement.innerHTML = mobileMenuCSS;
  document.head.appendChild(styleElement);
} 